import { useContext } from 'react';
import { CheckbookConfigurationContext } from 'src/sections/checkbook_configuration/CheckbookConfigurationContext';

const useCheckbookConfiguration = () => {
  const context = useContext(CheckbookConfigurationContext);
  if (!context)
    throw new Error(
      'Checkbook Configuration context must be used inside CheckbookConfigurationContextProvider'
    );
  return context;
};

export default useCheckbookConfiguration;
